// ABOUTME: The v28 deck: the canoe asset fitted so its manu tips stand above the horizon, rolling gently on the sea.
// ABOUTME: A fixed, clipped, click-through layer under the screens; the fit comes from deckFit and useHorizon.

import { Box } from '@mui/material';
import { buildInRise } from './deckBuildIn';
import { deckFit } from './horizon';
import { useHorizon } from './useHorizon';
import { useCrossingReducedMotion } from './useReducedMotion';

interface DeckSpriteProps {
  buildIn?: boolean; // 2A arriving from Ready for compass: the deck rises into place as the scene fades in
}

export default function DeckSprite({ buildIn = false }: DeckSpriteProps) {
  const reducedMotion = useCrossingReducedMotion();
  const { frameH, hz, phone } = useHorizon();
  const fit = deckFit(frameH, hz, phone);
  return (
    <Box
      data-testid="deck-layer"
      aria-hidden="true"
      sx={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: -1, ...(buildIn && !reducedMotion ? buildInRise : {}) }}
    >
      <Box
        data-testid="deck-sprite"
        sx={{
          position: 'absolute', width: `${fit.width}px`, top: `${fit.top}px`, left: '50%', marginLeft: `${-fit.width / 2}px`,
          transformOrigin: '50% 100%',
          '@keyframes pvDeckRoll': {
            '0%, 100%': { transform: 'rotate(-0.8deg) translateY(0)' },
            '50%': { transform: 'rotate(0.9deg) translateY(-5px)' },
          },
          animation: reducedMotion ? undefined : 'pvDeckRoll 6s ease-in-out infinite',
        }}
      >
        <img src="/crossing/1b-canoe.svg" alt="" aria-hidden="true" style={{ display: 'block', width: '100%', height: 'auto' }} />
      </Box>
    </Box>
  );
}
